'use strict';
(function () {
    $(document).ready(function () {
        $('.looking-foa-team .image-section').css('height', $('.looking-foa-team .text-section').outerHeight() + 'px');

        $('#jobsfilter-type input[type="radio"][value="jobs"]').prop('checked', true);
        var companiesCarousel = $('#companies-carousel');
        var testimonialsCarousel = $('#testimonials-carousel');
        var logosCarousel = $('.logos_carousel');

        logosCarousel.owlCarousel({
            loop: true,
            margin: 10,
            nav: true,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            navText: [
                '<i class="fa fa-angle-left" aria-hidden="true"></i>',
                '<i class="fa fa-angle-right" aria-hidden="true"></i>'
            ],
            responsive: {
                0: {
                    items: 2
                },
                600: {
                    items: 4
                },
                1000: {
                    items: 8
                }
            }
        });

        companiesCarousel.owlCarousel({
            loop: true,
            margin: 10,
            nav: true,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            navText: [
                '<i class="fa fa-angle-left" aria-hidden="true"></i>',
                '<i class="fa fa-angle-right" aria-hidden="true"></i>'
            ],
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 2
                },
                1000: {
                    items: 3
                }
            }
        });

        testimonialsCarousel.owlCarousel({
            loop: true,
            margin: 10,
            nav: true,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            navText: [
                '<i class="fa fa-angle-left" aria-hidden="true"></i>',
                '<i class="fa fa-angle-right" aria-hidden="true"></i>'
            ],
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 1
                },
                1000: {
                    items: 1
                }
            }
        });

        $('#jobsfilter-type input').iCheck({
            checkboxClass: 'icheckbox_square-'+$('#checkbox_color').val(),
            radioClass: 'iradio_square-' + $('#checkbox_color').val(),
            increaseArea: '20%'
        });

        $('#jobsfilter-type input').on('ifClicked', function () {
            var home_page_data = $('#home_categories_data');
            var home_page_search_section = $('#home_page_search_section');
            var catId = $(this).val();
            var json = home_page_data.attr('data-category-' + catId);
            var allCategory = '';
            if(catId === 'companies'){
                $('#home_page_city_filter').addClass('hidden');
                allCategory = home_page_data.attr('data-industry-all');
                home_page_search_section.find('.search-field').removeClass('col-lg-3 col-sm-3').addClass('col-lg-5 col-sm-5');
                home_page_search_section.find('.search-btn').removeClass('col-lg-3 col-sm-3').addClass('col-lg-2 col-sm-2');
            }
            else {
                $('#home_page_city_filter').removeClass('hidden');
                allCategory = home_page_data.attr('data-category-all');
                home_page_search_section.find('.search-field').addClass('col-lg-3 col-sm-3').removeClass('col-lg-5 col-sm-5');
                home_page_search_section.find('.search-btn').addClass('col-lg-3 col-sm-3').removeClass('col-lg-2 col-sm-2');
            }
            var categoryHtml = '<option value="">'+allCategory+'</option>';
            $.each( JSON.parse(json), function( key, value ) {
                categoryHtml += '<option value="' + key + '" >' + value + '</option>'
            });
            if(catId !== 'companies') {
                var cityJson = home_page_data.attr('data-cities-' + catId);
                var allCities = home_page_data.attr('data-cities-all');
                var citiesHtml = '<option value="">'+allCities+'</option>';
                $.each(JSON.parse(cityJson), function (key, value) {
                    citiesHtml += '<option value="' + key + '" >' + value + '</option>'
                });
                $('#jobsfilter-job_city').html(citiesHtml);
            }
            $('#jobsfilter-category').html(categoryHtml);
        });

        $('#home-search-form').on('submit', function(){

            if (!$('#jobsfilter-category').val()){
                $('#jobsfilter-category').attr('name', '');
            }
            if (!$('#jobsfilter-job_city').val()){
                $('#jobsfilter-job_city').attr('name', '');
            }

        });


        var sliderItems = [];
        $('#owl-view').find('img').each(function(key, val){
            sliderItems.push({
                src: $(val).attr('src'),
                w: 964,
                h: 1024
            });
        });
        $("#owl-view").owlCarousel({
            margin:10,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    nav:true,
                },
                600:{
                    items:3,
                    nav:false,
                },
                1000:{
                    items:5,
                    nav:true,
                }
            },
            nav: true,

            autoplay: true,
            autoplayTimeout: 3000,
            items: 4,
            navText: [
                '<i class="fa fa-angle-left" aria-hidden="true"></i>',
                '<i class="fa fa-angle-right" aria-hidden="true"></i>'
            ]
        });
        
        
        var openPhotoSwipe = function (index) {
            var pswpElement = document.querySelectorAll('.pswp')[0];            


            // define options (if needed)
            var options = {
                // history & focus options are disabled on CodePen        
                history: false,
                focus: false,
                index: index,
                showAnimationDuration: 0,
                hideAnimationDuration: 0,
                shareEl: false
            };
            
            

            var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, sliderItems, options);
            gallery.init();
        };
                
        
        $('.openSlider').on('click', function(){
            var key = $(this).data('index');
            $('.pswp__button--arrow--left').addClass('fa fa-angle-left');
            $('.pswp__button--arrow--right').addClass('fa fa-angle-right');
            $('.pswp__button--close').addClass('fa fa-times');
            openPhotoSwipe(key);
        });

        if($('#subscribe_modal').length) {
            setTimeout(function(){ $('#subscribe_modal').modal('show') }, 5000);
        }

        $('#subscribe_modal').on('hidden.bs.modal', function () {
            var url = $(this).find('#subscribe_form').attr('action');
            $.ajax({
                type: "POST",
                url: url,
                data: {id: 1},
            });
        });

    });
})();

